const faqItems = [
  {
    q: '黄瓜影院真的完全免费吗？',
    a: '是的，黄瓜影院所有影视内容均免费提供在线观看，无需注册、无需付费。我们通过合理的广告投放维持运营，确保观众能够享受高清在线观看不缓冲流畅播放的体验。',
  },
  {
    q: '为什么有些剧集搜索不到？',
    a: '我们的片库每日更新，覆盖绝大多数热门电视剧全集和电影大全。如果您暂时搜索不到某部作品，可能是版权方要求下架或该剧集暂未收录。您可以通过智能推荐发现同类型的高分替代剧集，也可以通过联系我们提交收录申请。',
  },
  {
    q: '播放卡顿或画质模糊怎么办？',
    a: '黄瓜影院默认提供1080P高清画质，并优化了播放器实现不缓冲流畅播放。如遇卡顿，建议切换网络环境或尝试刷新页面。我们持续升级服务器带宽，确保高峰时段也能快速找片、即点即播。',
  },
  {
    q: '能否下载剧集到本地离线观看？',
    a: '当前黄瓜影院为在线观看平台，暂不提供下载功能。您可以在任何有网络的设备上通过浏览器直接访问，全面适配手机、平板和电脑，随时随地追最新剧集完整版。',
  },
  {
    q: '智能推荐是如何运作的？',
    a: '智能推荐系统基于您的浏览历史和观看偏好，运用算法分析相似用户的观影行为，为您精准推送可能感兴趣的影视内容。您看得越多，推荐越准，帮您告别剧荒，发现下一部心头好。',
  },
  {
    q: '更新的剧集什么时候上线？',
    a: '我们建立了高效的自动化更新机制，热门剧集通常在首播后2小时内即可在黄瓜影院找到最新剧集完整版。首页\"最新动态\"区域实时展示当日更新内容，您也可以关注我们的社交账号获取更新提醒。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于黄瓜影院的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <details
              key={i}
              className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer hover:bg-background-200/50 transition-colors list-none">
                <h3 className="font-label text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-200 flex items-center justify-center group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-sm text-foreground-500"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}